import { PageFooterData } from 'components/PageFooter/types/PageFooterData';
import { getMainInternshipsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainInternshipsSearchRoutePath';
import { getMainJobsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainJobsSearchRoutePath';
import { getMainOrgSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainOrgSearchRoutePath';
import { getMainVolopsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainVolopsSearchRoutePath';
import { mainPostAListingRoute } from 'modules/main/main.routes';

export const pageFooterDataPt: PageFooterData = {
  findAJob: {
    title: 'Buscar Emprego',
    links: [
      {
        type: 'jobs',
        title: 'Empregos',
        href: getMainJobsSearchRoutePath({ lang: 'pt' }),
      },
      {
        type: 'internships',
        title: 'Estágios',
        href: getMainInternshipsSearchRoutePath({ lang: 'pt' }),
      },
      {
        type: 'organizations',
        title: 'Organizações',
        href: getMainOrgSearchRoutePath({ lang: 'pt' }),
      },
      {
        type: 'career-advice',
        title: 'Blog Carreira de Impacto',
        href: '/en/careers',
      },
    ],
  },
  takeAction: {
    title: 'Impactar',
    links: [
      {
        type: 'volops',
        title: 'Voluntariado',
        href: getMainVolopsSearchRoutePath({ lang: 'pt' }),
      },
      {
        type: 'events',
        title: 'Eventos',
        href: getMainVolopsSearchRoutePath({
          lang: 'pt',
          filters: { type: 'VOLOP', actionType: ['EVENT'] },
        }),
      },
      {
        type: 'donations',
        title: 'Doações',
        href: getMainVolopsSearchRoutePath({
          lang: 'pt',
          filters: { type: 'VOLOP', actionType: ['DONATION'] },
        }),
      },
      {
        type: 'idealist-movement',
        title: 'Movimento Idealista',
        href: '/pt/movimento',
      },
      {
        type: 'knowledge-base',
        title: 'Blog Idealista',
        href: '/pt/blog',
      },
    ],
  },
  postOnIdealist: {
    title: 'Anunciar',
    links: [
      {
        type: 'post-a-listing',
        title: 'Vaga ou Evento',
        href: mainPostAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Cadastre sua Organização',
        href: '/organizations/create',
      },
      {
        type: 'create-community-group',
        title: 'Cadastre seu Coletivo',
        href: '/organizations/create',
      },
    ],
  },
  aboutUs: {
    title: 'Sobre Nós',
    links: [
      {
        type: 'our-mission',
        title: 'Nosso Propósito',
        href: '/pt/sobre/idealist',
      },
      {
        type: 'our-team',
        title: 'Nossa Equipe',
        href: '/pt/sobre/equipe',
      },
      {
        type: 'donate',
        title: 'Doações para o Idealist',
        href: '/pt/doacao',
      },
    ],
  },
  learnMore: {
    title: 'Saiba mais',
    links: [
      {
        type: 'help-center',
        title: 'Central de Atendimento',
        href: '/pt/ajuda',
      },
      {
        type: 'contact-us',
        title: 'Entre em Contato',
        href: '/pt/about/contato',
      },
      {
        type: 'terms-of-service',
        title: 'Termos de Serviço (EN)',
        href: '/en/terms-of-service',
      },
      {
        type: 'privacy-policy',
        title: 'Política de Privacidade (EN)',
        href: '/en/privacy-policy',
      },
      {
        type: 'site-map',
        title: 'Mapa do Site',
        href: '/pt/mapa-do-site',
      },
    ],
  },
};
